import { render, staticRenderFns } from "./help_center_upgrade_subscription.vue.js?vue&type=template&id=7500c2d8!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./help_center_upgrade_subscription.vue?vue&type=template&id=7500c2d8"
import script from "./help_center_upgrade_subscription.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./help_center_upgrade_subscription.vue?vue&type=script&lang=js"
export * from "./help_center_upgrade_subscription.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./help_center_upgrade_subscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7500c2d8')) {
      api.createRecord('7500c2d8', component.options)
    } else {
      api.reload('7500c2d8', component.options)
    }
    module.hot.accept("./help_center_upgrade_subscription.vue.js?vue&type=template&id=7500c2d8!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./help_center_upgrade_subscription.vue?vue&type=template&id=7500c2d8", function () {
      api.rerender('7500c2d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ee/app/assets/javascripts/super_sidebar/components/help_center_upgrade_subscription.vue"
export default component.exports